import Cookies from "js-cookie";
import { axiosInstance } from "./axiosInstance";
import { logAnalyticsEvent } from "src/utils/Firebase";
import Swal from "sweetalert2";

export const AuthService = {
	login: async (email: string, password: string) => {
		return await axiosInstance.post("/api/auth/user/login", {
			email: email,
			password: password,
		});
	},
	register: async (
		name: string,
		email: string,
		username: string,
		phone: string,
		password: string,
		source: string,
		referral: string,
		recaptcha: string
	) => {
		return await axiosInstance.post("/api/auth/user/register", {
			name: name,
			email: email,
			username: username,
			phone: phone,
			password: password,
			source: source,
			referral_code: referral,
			recaptcha: recaptcha,
		});
	},
	me: async () => {
		try {
			const response = await axiosInstance.get("/api/auth/user/me");
			localStorage.setItem("USER", JSON.stringify(response.data.user));
			return response;
		} catch (err) {
			console.error(err);
			return null;
		}
	},
	resetPassword: async (oldPassword: string, newPassword: string) => {
		const response = await axiosInstance.post(
			"/api/feature/user/reset-password",
			{
				old_password: oldPassword,
				new_password: newPassword,
			}
		);
		return response;
	},
};

export const loginGoogle = async () => {
	window.location.href = `${process.env.REACT_APP_API_URL}/api/auth/user/social/login/google/`;
}
	
export const logout = async () => {
	try {
		const result = await Swal.fire({
			title: "Apakah Anda yakin?",
			text: "Akun Anda akan keluar dari aplikasi",
			icon: "warning",
			showCancelButton: true,
			confirmButtonText: "Ya, keluar!",
			cancelButtonText: "Tidak",
			confirmButtonColor: "#3C6F7D",
		});

		if (result.isConfirmed) {
			await axiosInstance.post(`/api/auth/logout`);
			logAnalyticsEvent("logout", { method: "delete_token" });

			const submateriProgress = JSON.parse(
				localStorage.getItem("SubmateriProgress") || "[]"
			);
			const seeTourDashboardCounter = localStorage.getItem("seeTourDashboardCounter");

			localStorage.clear();

			localStorage.setItem("SubmateriProgress", JSON.stringify(submateriProgress));
			if (seeTourDashboardCounter) {
				localStorage.setItem("seeTourDashboardCounter", seeTourDashboardCounter);
			}

			window.location.href = "/login";
		}
	} catch (error) {
		console.error("Logout failed:", error);
		Swal.fire({
			title: "Error",
			text: "Terjadi kesalahan saat keluar. Silakan coba lagi.",
			icon: "error",
		});
	}
};
	
export const logoutTentor = async () => {
	try {
		const result = await Swal.fire({
			title: "Apakah Anda yakin?",
			text: "Akun Anda akan keluar dari aplikasi",
			icon: "warning",
			showCancelButton: true,
			confirmButtonText: "Ya, keluar!",
			cancelButtonText: "Tidak",
			confirmButtonColor: "#3C6F7D",
		});

		if (result.isConfirmed) {
			await axiosInstance.post(`/api/feature/class/tentor/logout`);
			logAnalyticsEvent("logout", { method: "delete_token" });

			const submateriProgress = JSON.parse(
				localStorage.getItem("SubmateriProgress") || "[]"
			);
			const seeTourDashboardCounter = localStorage.getItem("seeTourDashboardCounter");

			localStorage.clear();

			localStorage.setItem("SubmateriProgress", JSON.stringify(submateriProgress));
			if (seeTourDashboardCounter) {
				localStorage.setItem("seeTourDashboardCounter", seeTourDashboardCounter);
			}

			window.location.href = "/login";
		}
	} catch (error) {
		console.error("Logout failed:", error);
		Swal.fire({
			title: "Error",
			text: "Terjadi kesalahan saat keluar. Silakan coba lagi.",
			icon: "error",
		});
	}
};

export const deleteAccount = async () => {
	try {
		const result = await Swal.fire({
			title: "Yakin ingin menghapus akun?",
      text: "Tindakan ini tidak dapat dibatalkan. Seluruh data Anda akan dihapus permanen",
      icon: "warning",
			showCancelButton: true,
			confirmButtonText: "Ya, hapus akun saya",
      cancelButtonText: "Batal",
			confirmButtonColor: "#3C6F7D",
		});

		if (result.isConfirmed) {
			await axiosInstance.delete(`/api/feature/user/self-delete`);
			logAnalyticsEvent("logout", { method: "delete_account" });
			localStorage.clear();
			Object.keys(Cookies.get()).forEach(function(cookieName) {
				Cookies.remove(cookieName);
			});

			let timerInterval;
			Swal.fire({
				icon: "success",
				title: "Akun Anda berhasil dihapus",
				timer: 2000,
				showConfirmButton: false,
				iconColor: "#3C6F7D",
				willClose: () => {
					clearInterval(timerInterval);
					window.location.href = "/login";
				}
			})
			
		}
	} catch (error) {
		console.error("Delete account failed:", error);
		Swal.fire({
			icon: "error",
			title: "Gagal",
			text: "Terjadi kesalahan saat menghapus akun."
		});
	}
};

export const getCurrentUser = () => {
	return JSON.parse(localStorage.getItem("USER") || "{}");
};

export const isLoggedIn = () => {
	return localStorage.getItem("TOKEN") ? true : false;
};

export const isParentLoggedIn = () => {
	return localStorage.getItem("PARENT_TOKEN") ? true : false;
}

export const isTentorLoggedIn = () => {
	return localStorage.getItem("TENTOR_TOKEN") ? true : false;
}

/* Forget Password */
export const forgetPassword = async (email: string) => {
	return await axiosInstance.get(
		"/api/auth/user/forgot-password/create?email=" + email
	);
};

export const resendForgetPassword = async (email: string) => {
	return await axiosInstance.get(
		"/api/auth/user/forgot-password/update?email=" + email
	);
};

export const validateForgetPassword = async (email: string, otp: string) => {
	return await axiosInstance.post("/api/auth/user/validate-forgot-password", {
		email: email,
		otp: otp,
	});
};

/* Forget Password Email */
export const sendOTPEmail = async (email: string) => {
	return await axiosInstance.get(
		"/api/auth/user/send-otp/email/create?email=" + email
	);
};

export const resendOTPEmail = async (email: string) => {
	return await axiosInstance.get(
		"/api/auth/user/send-otp/email/update?email=" + email
	);
};

export const validateOTPEmail = async (email: string, otp: string) => {
	return await axiosInstance.post("/api/auth/user/verify-otp/email", {
		email: email,
		otp: otp,
	});
};

export const updateForgetPassword = async (
	email: string,
	otp: string,
	password: string
) => {
	return await axiosInstance.post("/api/auth/user/update-forgot-password", {
		email: email,
		otp: otp,
		password: password,
	});
};

/* Verify Phone */
export const requestOTP = async () => {
	return await axiosInstance.get("/api/auth/user/register/send-otp");
};

export const requestResendOTP = async (phone: string) => {
	return await axiosInstance.get("/api/auth/user/register/resend-otp");
};

export const verifyOTP = async (otp: string) => {
	return await axiosInstance.post("/api/auth/user/register/verify-otp", {
		otp: otp,
	});
};
